/**
 * This exception is thrown when a user tries to login too many times
 */
export class TooManyTriesException extends Error {}
